import {Dispatch} from 'redux'

import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {
  Action,
  Category,
  Entity,
  Team
} from '@vio/core/src/analytics/types/Events'
import {authenticationErrored} from '@vio/core/src/auth/business/authenticationErrorEvent'
import {
  getAuthenticationOrigin,
  withoutOwnedOriginKeys
} from '@vio/core/src/auth/business/authenticationOrigin'
import {
  AuthenticationFlows,
  AuthenticationMethod,
  SourceComponentType
} from '@vio/core/src/auth/types/Auth'

// Email step
export const trackOnClickOneTimePassword = (
  sourceComponent: SourceComponentType | undefined,
  dispatch: Dispatch,
  analyticsData?: Record<string, unknown>
) => {
  dispatch(
    trackEvent({
      category: Category.User,
      entity: Entity.EmailAuthentication,
      action: Action.Clicked,
      component: sourceComponent || undefined,
      team: Team.Retention,
      payload: analyticsData ? {...analyticsData} : undefined
    })
  )
}

export const trackErrorOnRequestOneTimePassword = (
  sourceComponent: SourceComponentType | undefined,
  flow: AuthenticationFlows | null,
  error: string,
  dispatch: Dispatch
) => {
  dispatch(
    authenticationErrored({
      sourceComponent,
      flow,
      authenticationMethod: AuthenticationMethod.Email,
      errorType: 'EmailAuthentication',
      errorMessage: error
    })
  )
}

export const trackValidationError = (
  sourceComponent: SourceComponentType | undefined,
  flow: AuthenticationFlows | null,
  errorType: string,
  errorMessage: string,
  dispatch: Dispatch
) => {
  dispatch(
    authenticationErrored({
      sourceComponent,
      flow,
      authenticationMethod: AuthenticationMethod.Email,
      errorType,
      errorMessage
    })
  )
}

// Otp step
export const trackOnClickVerifyOneTimePassword = (
  sourceComponent: SourceComponentType | undefined,
  dispatch: Dispatch,
  analyticsData?: Record<string, unknown>
) => {
  const origin = getAuthenticationOrigin()

  dispatch(
    trackEvent({
      category: Category.User,
      entity: Entity.OTPAuthentication,
      action: Action.Submitted,
      component: sourceComponent ?? origin.sourceComponent,
      team: Team.Retention,
      payload: {
        ...withoutOwnedOriginKeys(analyticsData),
        authenticationFlow: origin.authenticationFlow
      }
    })
  )
}

export const trackSuccessfulAuthentication = (
  sourceComponent: SourceComponentType | undefined,
  dispatch: Dispatch,
  analyticsData?: Record<string, unknown>
) => {
  const origin = getAuthenticationOrigin()

  dispatch(
    trackEvent({
      category: Category.System,
      entity: Entity.Authentication,
      action: Action.Succeeded,
      component: sourceComponent || origin.sourceComponent || undefined,
      team: Team.Retention,
      payload: {
        authenticationMethod: 'Email',
        ...withoutOwnedOriginKeys(analyticsData),
        authenticationFlow: origin.authenticationFlow
      }
    })
  )
}

export const trackErrorOnVerifyOneTimePassword = (
  sourceComponent: SourceComponentType | undefined,
  flow: AuthenticationFlows | null,
  errorType: string,
  errorMessage: string,
  dispatch: Dispatch
) => {
  dispatch(
    authenticationErrored({
      sourceComponent,
      flow,
      authenticationMethod: AuthenticationMethod.Email,
      errorType,
      errorMessage
    })
  )
}
